export default __webpack_public_path__ + "static/media/Youtube.d0ce2ded.svg";